import { HeadBannerResponse } from '@shared/api/site-api/head-banner'

export const SearchParamKey = {
    REF_CODE: 'ref_code',
    COMPANY_INVITE_ID: 'companyInviteId', // need to be changed to `company_invite_id` in banxe-dashboard
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    REDIRECT_URL: 'redirectUrl', // need to be changed to `redirect_url` in banxe-dashboard
    // Signup attribution params appended by banxe.com/banxe.uk to /sign-up* links.
    SIGNUP_ORIGIN_DOMAIN: 'signup_origin_domain',
    SIGNUP_ORIGIN_PATH: 'signup_origin_path',
    LANDING_PAGE: 'landing_page',
    REFERRER: 'referrer',
    UTM_SOURCE: 'utm_source',
    UTM_MEDIUM: 'utm_medium',
    UTM_CAMPAIGN: 'utm_campaign',
    UTM_CONTENT: 'utm_content',
    UTM_TERM: 'utm_term',
    // Separate, independent from signup attribution: domain the user clicked "Login" from just now.
    LOGIN_ORIGIN_DOMAIN: 'login_origin_domain',
} as const

export type SearchParamKey = (typeof SearchParamKey)[keyof typeof SearchParamKey]

export interface IAppState {
    searchParams: Partial<Record<SearchParamKey, string | null | undefined>>
}

export type GlobalAlert = HeadBannerResponse & {
    show?: boolean,
}

export interface IAppSessionState extends IAppState {
    showGlobalAlert?: boolean
}

export type SearchParamsRecord = Record<SearchParamKey, string | null | undefined>

export const allSearchParamKeys: SearchParamKey[] = Object.values(SearchParamKey)

export const defaultSearchParams: SearchParamsRecord = Object.fromEntries(
    allSearchParamKeys.map((key) => [key, null])
) as SearchParamsRecord
